"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMenu = void 0;
var lodash_1 = require("lodash");
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
var setReactRef_1 = require("../../utils/setReactRef");
var ApMenuItem_1 = require("./ApMenuItem");
var context_1 = require("./context");
var styles_1 = require("./styles");
/**
 * Robust and composable menu component.
 *
 * It builds upon [Popper.js](https://popper.js.org) and all of its positioning logic,
 * e.g.:
 *
 * - it never hides behind window boundaries (or boundaries of the parent scroll element)
 * - it repositions itself as the user scrolls
 * - its position always follows the button (popover reference)
 *
 * Menus can be nested, simply by placing `<Menu>` inside a `<Menu>`.
 *
 * Complex menus can be build by combining the `<Menu>`, `<MenuItem>`, `<MenuSection>`,
 * `<MenuItemStatic`> and `<Divider>` components.
 */
exports.ApMenu = function (_a) {
    var button = _a.button, children = _a.children, disabled = _a.disabled, placementProp = _a.placement, _b = _a.initialOpen, initialOpen = _b === void 0 ? false : _b, toggleVariantProp = _a.toggleVariant, isOpenProp = _a.isOpen, toggleMenuProp = _a.toggleMenu, listProps = _a.listProps, className = _a.className, disableCloseOnSubmenuClick = _a.disableCloseOnSubmenuClick, onClose = _a.onClose, small = _a.small;
    var _c = __read(react_1.useState(false), 2), isOpenLocal = _c[0], setOpenLocal = _c[1];
    var isOpen = toggleMenuProp ? !!isOpenProp : isOpenLocal;
    var setOpen = toggleMenuProp || setOpenLocal;
    var ownRef = react_1.useRef();
    var _d = (typeof button !== 'function' ? button.props : {}).onClick, onClick = _d === void 0 ? lodash_1.noop : _d;
    var childRef = button.ref;
    var parent = react_1.useContext(context_1.default);
    var depth = parent.depth + 1;
    var toggleVariant = toggleVariantProp || (depth === 0 ? 'click' : 'hover');
    var placement = placementProp ||
        (depth === 0
            ? 'bottom-start'
            : 'right-start');
    var openMenu = react_1.useCallback(function () {
        if (!disabled) {
            setOpen(true);
        }
    }, [setOpen, disabled]);
    var closeMenu = react_1.useCallback(function (e) {
        if (disableCloseOnSubmenuClick &&
            e &&
            e.target &&
            e.target.closest('.ap-menu-submenu')) {
            return;
        }
        setOpen(false);
        if (onClose) {
            onClose();
        }
    }, [setOpen]);
    var closeAll = react_1.useCallback(function () {
        parent.closeMenu();
        closeMenu();
    }, [parent, closeMenu]);
    react_1.useLayoutEffect(function () {
        if (initialOpen) {
            setOpenLocal(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleRef = react_1.useCallback(function (value) {
        // If child has a `ref` already we must not override it
        setReactRef_1.setReactRef(childRef, value);
        ownRef.current = value;
    }, [childRef, ownRef]);
    var handleClick = react_1.useCallback(function (e) {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            setOpen(true);
        }
    }, [onClick, setOpen, disabled]);
    var hoverListeners = toggleVariant === 'hover' && {
        onMouseEnter: openMenu,
        onMouseLeave: closeMenu,
    };
    var newButtonProps = __assign({ disabled: disabled,
        small: small, onClick: handleClick, ref: handleRef }, (toggleVariant === 'hover' ? hoverListeners : null));
    return (React.createElement(React.Fragment, null,
        typeof button === 'function' && button(__assign(__assign({}, newButtonProps), { isOpen: isOpen })),
        typeof button !== 'function' &&
            React.cloneElement(button, __assign(__assign({}, newButtonProps), (button.type === ApMenuItem_1.ApMenuItem ? { isOpen: isOpen } : null))),
        isOpen && (React.createElement(styles_1.MenuContainer, __assign({ onClose: closeMenu, className: "" + (depth > 0 ? 'ap-menu-submenu ' : '') + (className ? className : ''), subMenu: depth > 0, referenceElement: ownRef.current, placement: placement }, hoverListeners, { hideArrow: true, modifiers: {
                // By default, Menu is not bound to the scrolling container.
                preventOverflow: {
                    boundariesElement: 'window',
                },
            }, containerProps: listProps }),
            React.createElement(context_1.default.Provider, { value: { closeMenu: closeMenu, closeAll: closeAll, isOpen: isOpen, depth: depth, small: small } }, children)))));
};
//# sourceMappingURL=ApMenu.js.map